export const GET_ACTORS = "GET_ACTORS";
export const LOADING = "LOADING";
export const GET_MOVIE = "GET_MOVIE";
export const SEARCH_ACTORS = "SEARCH_ACTORS";
